import { Button } from '@chakra-ui/react';
import { SiMeta } from '@icons-pack/react-simple-icons';
import { useTranslation } from 'react-i18next';
import { useMentionBoostInsightsQuery } from '@/hooks/queries/use-mention-boost-insights-query';

interface BoostInsightsMetaButtonProps {
  mentionId: string;
}

/**
 * Header action for the insights pane: a small outline button deep-linking to
 * the boost's ad in Meta Ads Manager, carrying the Meta logo. Reads the shared
 * insights query (deduped with the panel body, so it adds no extra fetch) and
 * renders nothing until a live ad reference exists.
 */
export function BoostInsightsMetaButton({ mentionId }: BoostInsightsMetaButtonProps) {
  const { t } = useTranslation();
  const { data } = useMentionBoostInsightsQuery({ mentionId });
  const url = data?.metaAdsManagerUrl;

  if (!url) {
    return null;
  }

  const label = t('mentions.boost.insights.viewOnMeta');

  return (
    <Button
      asChild
      size="sm"
      variant="outline"
      colorPalette="gray"
      gap={1.5}
      flexShrink={0}
      aria-label={label}
      data-testid="boost-insights-view-on-meta"
    >
      <a href={url} target="_blank" rel="noopener noreferrer">
        <SiMeta size={14} />
        {label}
      </a>
    </Button>
  );
}
